// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__cf1 {
  width: 100%;

  .label__a6a {
    color: var(--ring-secondary-color);
    font-size: var(--ring-font-size-smaller);
    line-height: var(--ring-line-height-lowest);
  }

  .forceBadge__a0b {
    margin-left: calc(var(--ring-unit) * 0.5);
  }

  .button__cfb {
    &.withBadge__f00 {
      padding-right: var(--ring-unit);
    }

    &.danger__e79 {
      &:hover:not(:disabled) {
        box-shadow: inset 0 0 0 1px var(--ring-error-color);
      }

      &:active {
        background-color: var(--ring-removed-background-color);
      }

      &.selected__d17 {
        box-shadow: inset 0 0 0 1px var(--ring-error-color);
        background-color: var(--ring-removed-background-color);
      }
    }

    &.success__d35 {
      &:hover:not(:disabled) {
        box-shadow: inset 0 0 0 1px var(--ring-success-color);
      }

      &:active {
        background-color: var(--ring-added-background-color);
      }

      &.selected__d17 {
        box-shadow: inset 0 0 0 1px var(--ring-success-color);
        background-color: var(--ring-added-background-color);
      }
    }
  }

  .label__a6a + .selector__a8f {
    margin-top: calc(var(--ring-unit) * 0.5);
  }

  .selector__a8f + .hint__cfa {
    margin-top: var(--ring-unit);
  }

  .selector__a8f + .info__c45 {
    margin-top: calc(var(--ring-unit) * 2);
  }
}

/* thanks ring ui*/
.wrapper__cf1 .selector__a8f .button__cfb:first-child .forceBadge__a0b,
.wrapper__cf1 .selector__a8f .button__cfb:last-child .forceBadge__a0b {
  border-radius: var(--ring-border-radius);
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/common/action-selector/action-selector.css"],"names":[],"mappings":"AAAA;EACE,WAAW;;EAEX;IACE,kCAAkC;IAClC,wCAAwC;IACxC,2CAA2C;EAC7C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE;MACE,+BAA+B;IACjC;;IAEA;MACE;QACE,mDAAmD;MACrD;;MAEA;QACE,sDAAsD;MACxD;;MAEA;QACE,mDAAmD;QACnD,sDAAsD;MACxD;IACF;;IAEA;MACE;QACE,qDAAqD;MACvD;;MAEA;QACE,oDAAoD;MACtD;;MAEA;QACE,qDAAqD;QACrD,oDAAoD;MACtD;IACF;EACF;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA,kBAAkB;AAClB;;EAEE,wCAAwC;AAC1C","sourcesContent":[".wrapper {\n  width: 100%;\n\n  .label {\n    color: var(--ring-secondary-color);\n    font-size: var(--ring-font-size-smaller);\n    line-height: var(--ring-line-height-lowest);\n  }\n\n  .forceBadge {\n    margin-left: calc(var(--ring-unit) * 0.5);\n  }\n\n  .button {\n    &.withBadge {\n      padding-right: var(--ring-unit);\n    }\n\n    &.danger {\n      &:hover:not(:disabled) {\n        box-shadow: inset 0 0 0 1px var(--ring-error-color);\n      }\n\n      &:active {\n        background-color: var(--ring-removed-background-color);\n      }\n\n      &.selected {\n        box-shadow: inset 0 0 0 1px var(--ring-error-color);\n        background-color: var(--ring-removed-background-color);\n      }\n    }\n\n    &.success {\n      &:hover:not(:disabled) {\n        box-shadow: inset 0 0 0 1px var(--ring-success-color);\n      }\n\n      &:active {\n        background-color: var(--ring-added-background-color);\n      }\n\n      &.selected {\n        box-shadow: inset 0 0 0 1px var(--ring-success-color);\n        background-color: var(--ring-added-background-color);\n      }\n    }\n  }\n\n  .label + .selector {\n    margin-top: calc(var(--ring-unit) * 0.5);\n  }\n\n  .selector + .hint {\n    margin-top: var(--ring-unit);\n  }\n\n  .selector + .info {\n    margin-top: calc(var(--ring-unit) * 2);\n  }\n}\n\n/* thanks ring ui*/\n.wrapper .selector .button:first-child .forceBadge,\n.wrapper .selector .button:last-child .forceBadge {\n  border-radius: var(--ring-border-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__cf1`,
	"label": `label__a6a`,
	"forceBadge": `forceBadge__a0b`,
	"button": `button__cfb`,
	"withBadge": `withBadge__f00`,
	"danger": `danger__e79`,
	"selected": `selected__d17`,
	"success": `success__d35`,
	"selector": `selector__a8f`,
	"hint": `hint__cfa`,
	"info": `info__c45`
};
export default ___CSS_LOADER_EXPORT___;
